export const manifest = {
  screens: {
    scr_7v1o74: { name: "Home", route: "/" },
  },
}
